import * as React from 'react';

const ModalFrameSeparator = () => (
  <hr className="modal-frame-separator" />
);

export default ModalFrameSeparator;
